import { Grid } from "@mui/material";
import React from "react";
import { IBrandExpert } from "./constants";
import { SingleExpert } from "./SingleExpert";
import ProCard from "../../../pro/Listing/components/ProCard";

interface IProductList {
  experts: Array<IBrandExpert>;
}

export function ExpertList({ experts }: IProductList) {
  return (
    <div className="my-8 grid  grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {experts.map((expert, i) => (
          <ProCard key={i} pro={expert} />
      ))}
    </div>
  );
}
